import { create } from 'zustand';
import type { EnrichmentStore, EnrichmentFromType } from './types';

export const useEnrichmentStore = create<EnrichmentStore>(set => ({
  enrichmentFrom: undefined,

  setEnrichmentFrom: (data: EnrichmentFromType) => {
    set({ enrichmentFrom: data });
  },

  clearEnrichmentFrom: () => {
    set({ enrichmentFrom: undefined });
  },
}));
